module.exports = __webpack_public_path__ + "static/media/add-square.2811e205.svg";